// extracted by mini-css-extract-plugin
module.exports = {"article":"article__1pcD6","img":"img__2q_0O","content":"content__96Bhj","title":"title__2zDpU","description":"description__3D6eV","read":"read__49two"};